import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Component responsible for displaying lesson script
 * Follows Single Responsibility Principle - only handles script display
 */
@Component({
  selector: 'app-lesson-script',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './lesson-script.component.html',
  styleUrl: './lesson-script.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LessonScriptComponent {
  taskId = input.required<string>();
  scriptUrl = input<string | undefined>(undefined);
  isLoading = input<boolean>(false);
  hasError = input<boolean>(false);
  script = input<string | null>(null);
}
